import React from 'react';
import styled from 'styled-components';
import theme from '../../../../ui/theme';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: ${({ $bgColor }) => $bgColor};
  border: 2px solid ${({ $borderColor }) => $borderColor};
  border-radius: 8px;
  min-height: 70px;
  transition: all 0.2s ease;
  box-shadow: ${({ $shadow }) => $shadow || 'none'};
  opacity: ${({ $opacity }) => $opacity || 1};

  &:hover {
    border-color: ${({ $hoverBorderColor }) => $hoverBorderColor};
    box-shadow: ${({ $hoverShadow }) => $hoverShadow};
    opacity: ${({ $hoverOpacity }) => $hoverOpacity || 1};
  }
`;

const ModuleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const ModuleType = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.NEU_500};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ModuleTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.NEU_900};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * MinimalModuleView component - Shows a compact card view during drag operations
 *
 * @param {Object} props
 * @param {string} props.moduleType - The type of module
 * @param {string} props.moduleTitle - The title/name of the module
 * @param {React.Component} props.IconComponent - The icon component to render
 * @param {string} props.themeColor - Theme color for the icon
 * @param {string} props.bgColor - Background color
 * @param {string} props.borderColor - Border color
 * @param {string} props.shadow - Box shadow
 * @param {string} props.hoverBorderColor - Border color on hover
 * @param {string} props.hoverShadow - Box shadow on hover
 * @param {number} props.opacity - Opacity (0-1)
 * @param {number} props.hoverOpacity - Opacity on hover (0-1)
 */
const MinimalModuleView = ({
  moduleType,
  moduleTitle,
  IconComponent,
  themeColor,
  bgColor,
  borderColor,
  shadow,
  hoverBorderColor,
  hoverShadow,
  opacity,
  hoverOpacity,
}) => {
  return (
    <Container
      $bgColor={bgColor}
      $borderColor={borderColor}
      $shadow={shadow}
      $hoverBorderColor={hoverBorderColor}
      $hoverShadow={hoverShadow}
      $opacity={opacity}
      $hoverOpacity={hoverOpacity}
    >
      <IconComponent size='medium' color={themeColor} />
      <ModuleInfo>
        <ModuleType>{moduleType}</ModuleType>
        <ModuleTitle>{moduleTitle}</ModuleTitle>
      </ModuleInfo>
    </Container>
  );
};

export default MinimalModuleView;
